import jwt_decode from "jwt-decode";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import ReactDrawer from "react-drawer";
import "react-drawer/lib/react-drawer.css";
//i18n
import { withTranslation } from "react-i18next";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import {
  AUTH_TOKEN,
  BU_TENANT_HEADER,
  ROLE_ADMIN,
  TENANT_CODE_HEADER,
} from "store/auth/login/actionTypes";
import logoLightSvg from "../../assets/images/logo-light.svg";
import logo from "../../assets/images/logo.svg";
// Redux Store
import {
  changeSidebarType,
  getListBUTenantHeader,
  getListTenantHeader,
  setBUTenantHeader,
  setTenantCodeHeader,
  showRightSidebarAction,
  toggleLeftmenu,
} from "../../store/actions";
import RightSidebar from "../CommonForBoth/RightSidebar";
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

const Header = props => {
  const [search, setsearch] = useState(false);
  const [megaMenu, setmegaMenu] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);

  const toggleTopDrawer = () => {
    setPosition("right");
    setOpen(!open);
  };

  const onDrawerClose = () => {
    setOpen(false);
  };

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  const Dashboard = useSelector(state => state.Dashboard);

  const { listTenant, tenantCodeHeader, listBuOfTenant } = Dashboard;
  const [isShowSelectTenant, setIsShowSelectTenant] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedBU, setSelectedBU] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    const info = localStorage.getItem(AUTH_TOKEN)
      ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
      : null;
    const roleUser = info?.["auth"];
    if (roleUser) {
      // Check if User admin thì cho chọn tenant
      if (roleUser === ROLE_ADMIN) {
        setIsShowSelectTenant(true);
      } else {
        // Không phải admin thì mặc định tenant của user login
        setIsShowSelectTenant(false);
        const tenantCode = info["userInfo"]["tenantCode"];
        dispatch(setTenantCodeHeader(tenantCode));
      }
    }
  }, []);

  useEffect(() => {
    if (isShowSelectTenant) {
      dispatch(getListTenantHeader());
    }
  }, [isShowSelectTenant]);

  useEffect(() => {
    if (tenantCodeHeader) {
      dispatch(getListBUTenantHeader());
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (listTenant && listTenant.length > 0) {
      const tenantCode = localStorage.getItem(TENANT_CODE_HEADER);
      if (tenantCode) {
        const value = listTenant.find(item => item.value === tenantCode);
        setSelectedTenant(value);
      } else {
        // Set mặc định tenant
        setSelectedTenant(listTenant[0]);
      }
    }
  }, [listTenant]);

  useEffect(() => {
    if (listBuOfTenant.length > 0) {
      const buTenant = localStorage.getItem(BU_TENANT_HEADER);
      if (buTenant) {
        const value = listBuOfTenant.find(item => item.value === buTenant);
        if (value) {
          setSelectedBU(value);
        } else {
          setSelectedBU(listBuOfTenant[0]);
        }
      } else {
        // Set mặc định BU
        setSelectedBU(listBuOfTenant[0]);
      }
    } else if (listBuOfTenant.length === 0) {
      setSelectedBU(null);
    }
  }, [JSON.stringify(listBuOfTenant)]);

  // Thay đổi tenant thì lưu vào local storage (x-tenant header)
  useEffect(() => {
    if (selectedTenant) {
      dispatch(setTenantCodeHeader(selectedTenant.value));
    }
  }, [selectedTenant]);

  // Thay đổi  đơn vị thì lưu vào local storage
  useEffect(() => {
    if (selectedBU) {
      dispatch(setBUTenantHeader(selectedBU.value));
    }
  }, [selectedBU]);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div
              className="d-flex align-items-center"
              style={{ marginRight: "12px", fontWeight: "bold" }}
            >
              Tenant:
            </div>
            {isShowSelectTenant ? (
              <div
                className="app-search d-lg-block"
                style={{ minWidth: "300px" }}
              >
                <Select
                  placeholder="Chọn Tenant muốn xem dữ liệu..."
                  value={selectedTenant}
                  onChange={e => {
                    setSelectedTenant(e);
                  }}
                  options={listTenant}
                  classNamePrefix="select2-selection"
                />
              </div>
            ) : (
              <div className="d-flex align-items-center text-primary">
                {tenantCodeHeader ? tenantCodeHeader : "Không hợp lệ"}
              </div>
            )}

            <React.Fragment>
              <div
                className="d-flex align-items-center"
                style={{
                  marginRight: "12px",
                  marginLeft: "30px",
                  fontWeight: "bold",
                }}
              >
                Đơn vị
              </div>
              <div
                className="app-search d-lg-block"
                style={{ minWidth: "300px" }}
              >
                <Select
                  placeholder="Chọn đơn vị..."
                  value={selectedBU}
                  onChange={e => {
                    setSelectedBU(e);
                  }}
                  options={listBuOfTenant}
                  classNamePrefix="select2-selection"
                />
              </div>
            </React.Fragment>

            <div className="dropdown-mega d-none d-lg-block ms-2"></div>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* <LanguageDropdown />
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div> */}

            <NotificationDropdown />
            <ProfileMenu />

            {/* <div
              onClick={toggleTopDrawer}
              disabled={open}
              className="dropdown d-inline-block"
            >
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
      <ReactDrawer open={open} position={position} onClose={onDrawerClose}>
        <RightSidebar onClose={onDrawerClose} />
      </ReactDrawer>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
